import * as React from 'react';
import styled from 'styled-components';
import { InputText } from 'ui/inputs';
import { GhostSuccessButton } from 'ui/button';
import { spacing } from 'ui/theme';

type Props = {
  id: string;
  value: string;
  onChange: (value: string) => void;
  onCleared: () => void;
  hasError?: boolean;
  isRequired?: boolean;
};

const Container = styled.div`
  display: flex;
  align-items: center;
  > :nth-child(1) {
    flex-grow: 1;
  }
  > :nth-child(2) {
    margin-left: ${spacing.half};
    text-align: center;
  }
`;

export const ClientSecretInput = ({
  id,
  value,
  onChange,
  onCleared,
  hasError,
  isRequired,
}: Props) => {
  const [editing, setEditing] = React.useState(!value);
  const inputRef = React.useRef<HTMLInputElement>(null);

  return (
    <Container>
      <InputText
        type="text"
        id={id}
        inputRef={inputRef}
        hasError={hasError}
        isRequired={isRequired}
        onChange={onChange}
        value={value || ''}
        isDisabled={!editing}
        isReadOnly={!editing}
      />
      {!editing && (
        <GhostSuccessButton
          onClick={() => {
            onCleared();
            setEditing(true);
            setTimeout(() => inputRef.current?.focus(), 0);
          }}
        >
          Clear
        </GhostSuccessButton>
      )}
    </Container>
  );
};
